import React from "react";
import { LinkBarProps } from "./LinkBar";
import * as styles from "./DesktopLinkBar.module.css";
import { Link } from "../../elements/Link/Link";

interface Props extends LinkBarProps {}

export const DesktopLinkBar: React.FC<Props> = ({ links, width }) => {
  const classes = [styles.linkbar];
  width === "contained" && classes.push(styles.contained);
  return (
    <nav
      className={classes.join(" ")}
      data-kontent-element-codename="link_configuration__links"
    >
      {links?.map((link, idx) => (
        <Link
          to={link.href}
          target={link.target}
          className={link.active ? styles.active : undefined}
          key={idx + link.href}
        >
          {link.label || link.pageTitle}
        </Link>
      ))}
    </nav>
  );
};
